import React, { useState, useEffect } from "react";
import cx from "classnames";
import Photo from "@components/photo";
import Icon from "@components/icon";
import Phrase from "@components/phrase";
import LocatorMap from "@components/locator-map";
import { m } from "framer-motion";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";
import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k");

const libraries = ["places"];
const ContactForm = ({ data = {} }) => {
  const { introText, primaryImage } = data;
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [searchBoxRef, setSearchBoxRef] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [hasValidAddress, setHasValidAdress] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    address: "",
    postalCode: "",
    firstName: "",
    lastName: "",
    telephone: "",
    email: "",
    customerType: "",
    urgency: "",
  });
  const [contactInfo, setContactInfo] = useState({
    address: "",
    postalCode: "",
    firstName: "",
    lastName: "",
    telephone: "",
    email: "",
    customerType: "",
    urgency: "",
  });
  const { isLoaded } = useLoadScript({
    // Enter your own Google Maps API key
    googleMapsApiKey: "AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k",
    libraries: libraries,
  });
  const confirmAddress = () => {
    // we need a postal code, so if there's no postal code, lets geocode the string
    if (!selectedPlace) {
      Geocode.fromAddress(contactInfo.address).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          const newSelectedPlace = {
            pos: {
              lat: lat,
              lng: lng,
            },
          };
          setSelectedPlace(newSelectedPlace);
        },
        (error) => {
          console.error(error);
        }
      );
    }

    // validate address before continuing
    const valid = true;
    if (contactInfo["address"]) {
      if (!contactInfo["address"].match(/^\d/)) {
        valid = false;
        setValidationErrors({
          ...validationErrors,
          address: "Please begin your address with a street number.",
        });
      }
    }
    if (valid) {
      setStep(2);
    }
  };
  const searchBoxPlacesChanged = () => {
    const currPlace = searchBoxRef.getPlaces()[0];
    const newSelectedPlace = {
      id: currPlace.place_id,
      pos: {
        lat: currPlace.geometry.location.lat(),
        lng: currPlace.geometry.location.lng(),
      },
    };
    const postalCodeComponent = currPlace.address_components.filter(
      (component, idx) => {
        if (component.types.includes("postal_code")) {
          return component;
        }
      }
    );
    setContactInfo({
      ...contactInfo,
      address: currPlace.formatted_address,
      postalCode: postalCodeComponent[0]?.short_name,
    });
    setSelectedPlace(newSelectedPlace);
  };
  const searchBoxLoadHandler = (searchBox) => {
    setSearchBoxRef(searchBox);
  };
  const handleChange = (event) => {
    setValidationErrors({ [event.target.name]: "" });
    setContactInfo({ ...contactInfo, [event.target.name]: event.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let form = contactInfo,
      valid = true;

    // validate postal code is numeric
    if (contactInfo["postalCode"]) {
      let isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(
        contactInfo["postalCode"]
      );
      if (!isValidZip) {
        valid = false;
        setValidationErrors({
          ...validationErrors,
          postalCode: "Please enter a valid postal code.",
        });
      }
    }

    if (contactInfo["address"]) {
      if (!contactInfo["address"].match(/^\d/)) {
        valid = false;
        setValidationErrors({
          ...validationErrors,
          address: "Please begin your address with a street number.",
        });
      }
    }

    if (!contactInfo["customerType"]) {
      valid = false;
      setValidationErrors({
        ...validationErrors,
        customerType: "Please select an option.",
      });
    }

    if (!contactInfo["urgency"]) {
      valid = false;
      setValidationErrors({
        ...validationErrors,
        urgency: "Please select an option.",
      });
    }

    if (valid) {
      // add loader
      if (window && window.gtag) {
        window.gtag("event", "order_form_submit");
      }
      setIsLoading(true);
      const rawResponse = await fetch("/api/dwell/process-form", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });
      const content = await rawResponse.json();
      if (content) {
        window.scrollTo(0, 0);

        window.location.href = "/thank-you";
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (step == 2) {
      setTimeout(function () {
        setStep(3);
      }, 2000);
    }
    if (step == 3) {
      setTimeout(function () {
        setStep(4);
      }, 3000);
    }
  });
  return (
    <section
      className={cx(
        "contact-form",
        "md:h-[100px]",
        "md:min-h-[calc(100vh-var(--header-height))]"
      )}
    >
      <div className={cx("grid", "grid-cols-20", "md:h-full")}>
        <div
          className={cx(
            "col-span-20",
            "md:col-span-10",
            "flex",
            "flex-col",
            "place-content-center",
            "h-[300px]",
            "overflow-hidden",
            "md:h-full",
            "text-center"
          )}
        >
          {step === 4 && (
            <div className={cx("h-full", "bg-[#dddddd]")}>
              <LocatorMap displayLocation={selectedPlace} />
            </div>
          )}
          {step !== 4 && (
            <div className="relative h-full">
              {primaryImage && (
                <Photo photo={primaryImage} width={1200} layout="fill" />
              )}
            </div>
          )}
        </div>
        <div
          className={cx(
            "col-span-16",
            "col-start-3",
            "md:col-span-8",
            "md:col-start-12",
            "flex",
            "flex-col",
            "place-content-center",
            "h-auto",
            "md:h-full",
            "py-[20px]"
          )}
          data-theme="gray"
        >
          {step === 1 && (
            <div className={cx("mx-auto", "form")}>
              <p
                className={cx(
                  "text-lg-3",
                  "uppercase",
                  "text-center",
                  "mb-[50px]",
                  "mx-auto"
                )}
              >
                {introText}
              </p>
              {isLoaded && (
                <div className="input-wrap">
                  <label>Address</label>
                  <StandaloneSearchBox
                    onLoad={searchBoxLoadHandler}
                    onPlacesChanged={searchBoxPlacesChanged}
                  >
                    <input
                      onChange={handleChange}
                      name="address"
                      type="text"
                      value={contactInfo.address}
                      placeholder="Enter your address"
                    />
                  </StandaloneSearchBox>
                  {validationErrors["address"] && (
                    <div className={cx("text-[#ff0000]")}>
                      {validationErrors["address"]}
                    </div>
                  )}
                </div>
              )}
              <div className="input-wrap text-center">
                <button
                  disabled={!contactInfo.address}
                  onClick={() => confirmAddress()}
                  className={cx("text", "uppercase")}
                >
                  Next{" "}
                  <div className={cx("long-arrow")}>
                    <Icon
                      name="LongArrow"
                      color="#000000"
                      viewBox="0 0 47 13"
                    />
                  </div>
                </button>
              </div>
            </div>
          )}
          {step === 2 && (
            <m.div
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              transition={{ duration: 1 }}
              className={cx("mx-auto", "form")}
            >
              <div
                className={cx(
                  "text-lg-2-mobile",
                  "md:text-lg-2",
                  "text-center",
                  "mb-[50px]",
                  "max-w-[50%]",
                  "mx-auto"
                )}
              >
                <Phrase
                  phrase="Locating - your property"
                  vertical="true"
                  dividerMaxWidth="300px"
                  hideLast={true}
                  typeStyle={"text-jumbo-mobile md:text-jumbo"}
                />
              </div>
            </m.div>
          )}
          {step === 3 && (
            <m.div
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              transition={{ duration: 2 }}
              className={cx("mx-auto", "form")}
            >
              <div
                className={cx(
                  "text-lg-2-mobile",
                  "md:text-lg-2",
                  "text-center",
                  "mb-[50px]",
                  "max-w-[50%]",
                  "mx-auto"
                )}
              >
                <Phrase
                  phrase="Address Found"
                  hideLast={true}
                  typeStyle={"text-jumbo-mobile md:text-jumbo"}
                />
              </div>
            </m.div>
          )}
          {step === 4 && (
            <form className={cx("mx-auto", "form")} onSubmit={handleSubmit}>
              <p
                className={cx(
                  "text-lg-3",
                  "uppercase",
                  "text-center",
                  "mb-[50px]",
                  "mx-auto"
                )}
              >
                Tell Us More About Yourself
              </p>
              <div className="grid md:grid-cols-2 md:gap-5">
                <div className="input-wrap col-span-1">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    onChange={handleChange}
                    name="firstName"
                    id="firstName"
                    type="text"
                    value={contactInfo.firstName}
                    required
                  />
                </div>
                <div className="input-wrap col-span-1">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    onChange={handleChange}
                    name="lastName"
                    id="lastName"
                    type="text"
                    value={contactInfo.lastName}
                    required
                  />
                </div>
              </div>
              <div className="input-wrap">
                <label htmlFor="telephone">Telephone</label>
                <input
                  onChange={handleChange}
                  name="telephone"
                  id="telephone"
                  type="tel"
                  value={contactInfo.telephone}
                  required
                />
              </div>
              <div className="input-wrap">
                <label htmlFor="email">Email</label>
                <input
                  onChange={handleChange}
                  name="email"
                  id="email"
                  type="email"
                  required
                />
              </div>
              <div className="input-wrap">
                <label htmlFor="address">Address</label>
                <input
                  onChange={handleChange}
                  name="address"
                  id="address"
                  type="address"
                  value={contactInfo.address}
                  required
                  disabled
                />
                {validationErrors["address"] && (
                  <div className={cx("text-[#ff0000]")}>
                    {validationErrors["address"]}
                  </div>
                )}
              </div>
              <div className="input-wrap">
                <label htmlFor="address">Postal Code</label>
                <input
                  onChange={handleChange}
                  name="postalCode"
                  id="postalCode"
                  type="postalCode"
                  value={contactInfo.postalCode}
                  required
                />
                {validationErrors["postalCode"] && (
                  <div className={cx("text-[#ff0000]")}>
                    {validationErrors["postalCode"]}
                  </div>
                )}
              </div>
              <div className="input-wrap select">
                <label htmlFor="customerType">I am a</label>
                <select
                  onChange={handleChange}
                  id="customerType"
                  name="customerType"
                  value={contactInfo.customerType}
                  required
                >
                  <option>----</option>
                  <option value="a Homeowner">Homeowner</option>
                  <option value="Future Homeowner">Future homeowner</option>
                  <option value="Real Estate Agent">Real estate agent</option>
                  <option value="Real Estate Developer">
                    Real estate developer
                  </option>
                  <option value="a Homeowner with an existing ADU">
                    Homeowner with an existing ADU
                  </option>
                </select>
                <div className="icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="11.5" stroke="#252524" />
                    <path d="M7 10L12 15L17 10" stroke="#252524" />
                  </svg>
                </div>
                {validationErrors["customerType"] && (
                  <div className={cx("text-[#ff0000]")}>
                    {validationErrors["customerType"]}
                  </div>
                )}
              </div>
              <div className="input-wrap select">
                <label htmlFor="urgency">Desired project start date?</label>
                <select
                  onChange={handleChange}
                  name="urgency"
                  id="urgency"
                  value={contactInfo.urgency}
                  required
                >
                  <option>----</option>
                  <option value="ASAP!">ASAP</option>
                  <option value="1-3 Months">1-3 months</option>
                  <option value="3-6 Months">3-6 months</option>
                  <option value="6 Months+">6+ months</option>
                </select>
                <div className="icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12" cy="12" r="11.5" stroke="#252524" />
                    <path d="M7 10L12 15L17 10" stroke="#252524" />
                  </svg>
                </div>
                {validationErrors["urgency"] && (
                  <div className={cx("text-[#ff0000]")}>
                    {validationErrors["urgency"]}
                  </div>
                )}
              </div>
              <div className="input-wrap text-center">
                <button
                  className={cx("text", "uppercase")}
                  disabled={isLoading}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
